import { useQuery } from '@tanstack/react-query';
import { fetchCurrentEmergency } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useFetchCurrentEmergency = () =>
  useQuery({
    queryFn: () => extractData(fetchCurrentEmergency()),
    queryKey: ['emergencyMode', 'current'],
    retry: false,
  });
